import * as overview from "./overview";
import * as map from "./map";
import * as applicant from "./applicant";
import * as inventor from "./inventor";
import * as ipc from "./ipc";
import * as agency from "./agency";

export const SYSTEM_REPORT_TREE: Array<any> = [
  {
    id: null,
    label: "概览"
  },
  {
    id: 0,
    label: "概况分析",
    children: [
      overview.patentType,
      overview.appCount,
      overview.authCount,
      overview.applicantCount,
      overview.inventorCount,
      overview.lifeCycleCount
    ]
  },
  {
    id: 20,
    label: "地域分析",
    children: [
      map.country,
      map.province,
      map.provinceAppYear,
      map.provinceAuthYear,
      map.provinceApplicant,
      map.provinceIpc
    ]
  },
  {
    id: 40,
    label: "申请人分析",
    children: [
      applicant.applicantCount,
      applicant.applicantAppYear,
      applicant.applicantAuthYear,
      applicant.applicantIpc,
      applicant.applicantPatentType,
      applicant.applicantLegalStatus,
      applicant.applicantCooperation
    ]
  }, {
    id: 60,
    label: "发明人分析",
    children: [
      inventor.inventorCount,
      inventor.inventorAppYear,
      inventor.inventorAuthYear,
      inventor.inventorIpc
    ]
  },
  {
    id: 80,
    label: "IPC主分类分析",
    children: [
      ipc.miniIpcCount,
      ipc.miniIpcAppYear,
      ipc.miniIpcApplicant,
      ipc.shortIpcCount,
      ipc.shortIpcAppYear,
      ipc.shortIpcApplicant,
      ipc.primaryIpcCount,
      ipc.primaryIpcAppYear,
      ipc.primaryIpcApplicant
    ]
  },
  {
    id: 100,
    label: "IPC分析",
    children: [
      ipc.ipcCount,
      ipc.ipcAppYear,
      ipc.ipcApplicant
    ]
  },
  {
    id: 120,
    label: "代理机构分析",
    children: [
      agency.agencyCount,
      agency.agencyAppYear,
      agency.agencyAuthYear,
      agency.agencyIpc
    ]
  }
];
